module.exports = __webpack_public_path__ + "static/img/m_name.63876d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/mz/m_name.png
// module id = 066U
// module chunks = 7